import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceOrdersEntityState} from "../reducers/ecommerce-orders.reducer";
import {IOrder, PaymentStatusEnum} from "../../websites/website/ecommerce/orders/orders.interface";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceOrdersState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceOrders.entities[websiteId]);

export const getOrders = (websiteId: number) => createSelector(getEcommerceOrdersState(websiteId),
  (state: IEcommerceOrdersEntityState) => {
    if (state && state.orders) {
      state.orders.map((order: IOrder) => {
        order.payment_status = PaymentStatusEnum[order.status];
        order.customer = order.customer_data;
        return order;
      });
    }
    return state;
  }
);

export const getOrderById = (websiteId: number, orderId) => createSelector(getEcommerceOrdersState(websiteId),
  (state: IEcommerceOrdersEntityState) => {
    let order: IOrder;
    if (state && state.orders) {
      state.orders.map((order: IOrder) => {
        order.payment_status = PaymentStatusEnum[order.status];
        order.customer = order.customer_data;
        return order;
      });
      order = state.orders.find(order => order?.id === orderId);
    }
    return order;
  }
);

export const getOrdersLoading = (websiteId: number) => createSelector(getEcommerceOrdersState(websiteId),
  (state: IEcommerceOrdersEntityState) => state && state.loading
);

export const getOrder = (websiteId: number) => createSelector(getEcommerceOrdersState(websiteId),
  (state: IEcommerceOrdersEntityState) => {
    return state && state.order;
  }
);

export const getOrdersLoaded = (websiteId: number) => createSelector(getEcommerceOrdersState(websiteId),
  (state: IEcommerceOrdersEntityState) => state.loaded
);

export const getOrderFiled = (websiteId: number) => createSelector(getEcommerceOrdersState(websiteId),
  (state: IEcommerceOrdersEntityState) => state && state.failed
);
